<p class="label">
  {{ label }}
</p>